import React from 'react';
import logo from './logo.svg';
import './App.css';
import LicensePage from './Page/License';

function App() {
  return (
    <LicensePage/>
  
  );
}

export default App;
